import request from '../../../../../api/request';

const BASE = '/maintainers-portal/financial-portal/settings';

export interface CurrencyRateSummary {
  value: number;
  validFrom: string;
}

export interface CurrencyOverviewItem {
  id: number;
  code: string;
  name: string;
  symbol: string;
  isPrincipal: boolean;
  rate: CurrencyRateSummary | null;
}

export interface CurrenciesOverview {
  principal: CurrencyOverviewItem;
  secondary: CurrencyOverviewItem[];
}

export interface CurrencyRateCreated {
  id: number;
  value: number;
  validFrom: string;
  createdById: number | null;
  createdAt: string;
}

export interface CurrencyYearValue {
  date: string;
  value: number;
}

export function getCurrencies() {
  return request<CurrenciesOverview>(`${BASE}/currencies`);
}

export function getCurrencyRateYears(currencyId: number) {
  return request<{ years: number[] }>(`${BASE}/currencies/${currencyId}/rates/years`);
}

export function getCurrencyRatesByYear(currencyId: number, year: number) {
  return request<{ year: number; values: CurrencyYearValue[] }>(
    `${BASE}/currencies/${currencyId}/rates/year/${year}`,
  );
}

/** Sigue el mismo patrón que AcademicRecord/requests.ts: `responseType: 'blob'`
 * es obligatorio, si no axios parsea el binario como texto y el archivo
 * guardado queda corrupto. */
export function exportCurrencyRatesByYear(currencyId: number, year: number) {
  return request<any>(`${BASE}/currencies/${currencyId}/rates/year/${year}/export`, {
    responseType: 'blob',
  });
}

export function createCurrencyRate(
  currencyId: number,
  body: { value: number; validFrom: string },
) {
  return request<CurrencyRateCreated>(`${BASE}/currencies/${currencyId}/rates`, {
    method: 'post',
    data: body,
  });
}

/** Trae el valor de la UF del día desde mindicador.cl y lo guarda (WI-16486). */
export function syncCurrencyRate(currencyId: number) {
  return request<CurrencyRateCreated>(
    `${BASE}/currencies/${currencyId}/rates/sync`,
    { method: 'post' },
  );
}
